// src/mixins/bookingMixin.js
import { createBooking, updateBooking } from "@/utils/bookings";
import { vincularReserva } from "@/services/clientesDirectorio";
import { $toast } from "@/utils/useToast";
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("property", ["getProperty"]),

    async handleSaveReservation(reservation, { start, end }) {
      // Validar disponibilidad antes de guardar
      if (
        this.isDateRangeAvailable &&
        !this.isDateRangeAvailable(reservation.propertyId, start, end)
      ) {
        $toast.warning("⚠️ Las fechas ya están reservadas o bloqueadas");
        return false;
      }

      try {
        const newReserva = {
          start_date: reservation.start,
          end_date: reservation.end,
          name: reservation.name,
          email: reservation.email,
          phone: reservation.phone,
          property_id: reservation.propertyId,
          number_of_guests: reservation.number_of_guests,
          price: reservation.price,
          property_title: reservation.propertyTitle,
          status: "booked",
          user_id: this.$store.state.userRoot.id,
          // Desglose de la reserva directa (noches, limpieza, cargos): solo viaja si el
          // precio es el suyo, así que lo que se guarda siempre suma lo cobrado.
          quote_data: reservation.quote_data || null,
          crm_chat_id: reservation.crm_chat_id || null,
          crm_waba_phone_number_id: reservation.crm_waba_phone_number_id || null,
        };

        const response = await createBooking(newReserva);

        // Reserva hecha a nombre de un cliente del directorio: queda en su ficha.
        // Sin esperar ni avisar si falla: la reserva ya está creada.
        if (reservation.directorio_cliente_id && response?.data?.id) {
          vincularReserva(reservation.directorio_cliente_id, response.data.id).catch(() => {});
        }

        // Emitir evento global para actualizar calendarios
        this.$root.$emit("booking-created", response.data);
        this.getProperty(reservation.propertyId);

        // ✅ Un único toast desde la acción de creación (los calendarios solo
        // actualizan su estado, no muestran toast, para evitar duplicados).
        $toast.success(this.$t("empresa.reservas.p152"));
        return true;
      } catch (error) {
        const errorMsg =
          error.response?.data?.error ||
          error.response?.data?.message ||
          "No se pudo crear la reserva";
        $toast.error(errorMsg);
        return false;
      }
    },

    async handleUpdateReservation(reservation) {
      // Validar si las fechas o propiedad cambiaron
      const datesChanged =
        reservation.start !== reservation.originalStart ||
        reservation.end !== reservation.originalEnd;
      const propertyChanged =
        reservation.propertyId !== reservation.originalPropertyId;

      // Si cambiaron fechas o propiedad, validar disponibilidad
      if (
        (datesChanged || propertyChanged) &&
        this.isDateRangeAvailable &&
        !this.isDateRangeAvailable(
          reservation.propertyId,
          reservation.start,
          reservation.end,
          reservation.id
        )
      ) {
        $toast.warning("⚠️ Las nuevas fechas ya están reservadas o bloqueadas");
        return false;
      }

      try {
        const updatedReserva = {
          id: reservation.id,
          start_date: reservation.start,
          end_date: reservation.end,
          name: reservation.name,
          email: reservation.email,
          phone: reservation.phone,
          property_id: reservation.propertyId,
          number_of_guests: reservation.number_of_guests,
          price: reservation.price,
          property_title: reservation.propertyTitle,
          status: "booked",
          user_id: reservation.user_id,
          original_start_date: reservation.originalStart,
          original_end_date: reservation.originalEnd,
          original_property_id: reservation.originalPropertyId,
          resend_confirmation: !!reservation.resend_confirmation,
        };

        const response = await updateBooking(updatedReserva);

        // Emitir evento global para actualizar calendarios
        this.$root.$emit("booking-updated", response.data);
        this.getProperty(reservation.propertyId);
        this.$store.state.updateComplete = true;

        // toastr.success("Reserva actualizada exitosamente");
        return true;
      } catch (error) {
        return false;
      }
    },
  },
};
